var FormItem = require("./FormItem")
var BFormItem = require("./form/BFormItem")
var ExtendForm = require("./form/ExtendForm")
var BForm = require("./form/BForm")
var Tree = require("./Tree")
var Language = require("./Language")
var QForm = require("./QForm");//qualifyName->生成表单
var Avatar = require("./Avatar")
var HeadTitle = require("./HeadTitle")
var DropMenu = require("./DropMenu")
var RecordItem = require("./RecordItem")
var SingleForm = require("./SingleForm")
var UserCenterHeader = require("./UserCenterHeader")
var Login = require("../component/login/template/Login")//默认模板
var ConciseLogin = require("../component/login/conciseTemplate/ConciseLogin")//简洁模板
var SmallConcise = require("../component/login/smallConcise/SmallConcise")//简洁模板-小
var TabLogin = require("../component/login/tabLogin/TabLogin")//切换登录页面
var AppList = require("../component/appList/AppList")
var AuthList = require("../component/appConfig/AuthList")
var ShopList = require("../component/shopList/ShopList")
var WechatBind = require("../component/login/wechatBind/WechatBind")
var ResetPassword = require("../component/resetPassword/RestPassword")
var IdShield = require("../component/idShield/IdShield")
var ManageAuth = require("../component/appConfig/template/ManageAuth")
var EditAttr = require("../component/appConfig/template/EditAttr")
var Record = require("../component/appConfig/template/Record")
var Track = require("../component/track/Track")
var UserInfo = require("../component/userInfo/UserInfo")
var SSO = require("../component/sso/SSO")
var SSOLogin = require("../component/sso/SSOLogin")
var Prevent = require("../component/prevent/Prevent")
var WorkHeader = require("../component/workflow/WorkHeader")
var AccountApply = require("../component/workflow/AccountApply")
var Workflow = require("../component/workflow/Workflow")
var Notice = require("../component/systemNotice/Notice")
var AppListSort = require("../component/appSort/AppListSort")
var Entitlement = require("../component/entitlement/Entitlement")
var ManagerDetail = require("../component/appManager/ManagerDetail")
var UserTask = require("../component/userTask/UserTask")
var Logout = require("../component/logout/Logout")
var Reg = require("../component/reg/Reg")

module.exports = {
    commonsRegistered: false,
    loginRegistered: false,
    wechatBindRegistered: false,
    restPasswordRegistered: false,
    appListRegistered: false,
    authListRegistered: false,
    idShieldRegistered: false,
    manageAuthRegistered:false,
    editAttrRegistered:false,
    recordRegistered:false,
    trackRegistered:false,
    userInfoRegistered:false,
    globalRegistered: false,
    ssoRegistered: false,
    ssoLoginRegistered:false,
    shopListRegistered:false,
    preventRegistered: false,
    workflowRegistered: false,
    accountApplyRegistered:false,
    workHeaderRegistered:false,
    noticeRegistered:false,
    appListSortRegistered:false,
    entitlementRegistered:false,
    managerDetailRegistered:false,
    userTaskRegistered:false,
    logoutRegistered:false,
    regRegistered:false,
    registerGlobal: function () {
        if (!this.globalRegistered) {
        }
    },
    registerCommons: function () {
        if (!this.commonsRegistered) {
            this.commonsRegistered = true;
            BForm.register();
            BFormItem.register();
            ExtendForm.register();
            QForm.register();
            Tree.register();
            FormItem.register();
            Avatar.register();
            DropMenu.register();
            HeadTitle.register();
            RecordItem.register();
            SingleForm.register();
            UserCenterHeader.register();
            Language.register();
        }
    }, registerLogin: function () {
        if (!this.loginRegistered) {
            this.loginRegistered = true;
            Login.register();
            ConciseLogin.register();
            TabLogin.register();
            SmallConcise.register();
        }
    }, registerWechatBind: function () {
        if (!this.wechatBindRegistered) {
            this.wechatBindRegistered = true;
            WechatBind.register();
        }
    },registerRestPassword: function () {
        if (!this.restPasswordRegistered) {
            this.restPasswordRegistered = true;
            ResetPassword.register();
        }
    }, registerAppList: function () {
        if (!this.appListRegistered) {
            this.appListRegistered = true;
            AppList.register();
        }
    },registerAuthList: function () {
        if (!this.authListRegistered) {
            this.authListRegistered = true;
            AuthList.register();
        }
    }, registerShopList: function () {
        if (!this.shopListRegistered) {
            this.shopListRegistered = true;
            ShopList.register();
        }
    }, registerIdShield: function () {
        if (!this.idShieldRegistered) {
            this.idShieldRegistered = true;
            IdShield.register();
        }
    },registerManageAuth: function () {
        if (!this.manageAuthRegistered) {
            this.manageAuthRegistered = true;
            ManageAuth.register();
        }
    },registerEditAttr: function () {
        if (!this.editAttrRegistered) {
            this.editAttrRegistered = true;
            EditAttr.register();
        }
    },registerRecord: function () {
        if (!this.recordRegistered) {
            this.recordRegistered = true;
            Record.register();
        }
    },registerTrack: function () {
        if (!this.trackRegistered) {
            this.trackRegistered = true;
            Track.register();
        }
    },registerUserInfo: function () {
        if (!this.userInfoRegistered) {
            this.userInfoRegistered = true;
            UserInfo.register();
        }
    },registerSSO: function(){
        if (!this.ssoRegistered) {
            this.ssoRegistered = true;
            SSO.register();
        }
    }, registerSSOLogin: function(){
        if (!this.ssoLoginRegistered) {
            this.ssoLoginRegistered = true;
            SSOLogin.register();
        }
    },registerReg: function(){
        if (!this.regRegistered) {
            this.regRegistered = true;
            Reg.register();
        }
    },registerLogout: function(){
        if (!this.logoutRegistered) {
            this.logoutRegistered = true;
            Logout.register();
        }
    },registerPrevent: function(){
        if (!this.preventRegistered) {
            this.preventRegistered = true;
            Prevent.register();
        }
    },registerWorkHeader: function(){
        if (!this.workHeaderRegistered) {
            this.workHeaderRegistered = true;
            WorkHeader.register();
        }
    },
    registerWorkflow: function(){
        if (!this.workflowRegistered) {
            this.workflowRegistered = true;
            Workflow.register();
        }
    },
    registerAccountApply: function(){
        if (!this.accountApplyRegistered) {
            this.accountApplyRegistered = true;
            AccountApply.register();
        }
    },
    registerNotice: function(){
        if (!this.noticeRegistered) {
            this.noticeRegistered = true;
            Notice.register();
        }
    },
    registerAppListSort: function(){
        if (!this.appListSortRegistered) {
            this.appListSortRegistered = true;
            AppListSort.register();
        }
    },
    registerEntitlement: function(){
        if (!this.entitlementRegistered) {
            this.entitlementRegistered = true;
            Entitlement.register();
        }
    },
    registerManagerDetail: function(){
        if (!this.managerDetailRegistered) {
            this.managerDetailRegistered = true;
            ManagerDetail.register();
        }
    },
    registerUserTask: function(){
        if (!this.userTaskRegistered) {
            this.userTaskRegistered = true;
            UserTask.register();
        }
    }
    
}


//////////////////
// WEBPACK FOOTER
// ./src/template/kotemplates.js
// module id = 67
// module chunks = 0